<script setup>
import {computed, inject} from "vue";

const props = defineProps({
    stepName: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
});


const wizard = inject('wizard');


const step = computed(() => {
    return wizard.getStep(props.stepName);
});

const status = computed(() => {
    if (wizard.currentStep.value.name === props.stepName) {
        return 'active';
    }
    try {
        if (step.value.index < wizard.currentStep.value.index) {
            return 'completed';
        }
    } catch (e) {
        debugger
    }

    return 'future';
});

</script>

<template>
    <div class="wizard-progress__step"
         :class="[`wizard-progress__step--${status}`, {'wizard-progress__step--with-value': $slots.default}]">
        <div class="wizard-progress__step-title">{{ label }}</div>
        <div v-if="$slots.default" class="wizard-progress__step-value">
            <slot></slot>
        </div>
    </div>
</template>
